import { ApiResponse, createAuthenticatedApiCall } from '../utils/apiCall';
import type { ApiRequestConfig } from './models/ApiRequestConfig';

// Request/Response types
interface DeactivateInsuranceRequest {
    travelId: string;
    deactivatedOn: string;
    source: 'Web';
}

interface DeactivateInsuranceResponse {
    title?: string;
    errors?: string;
    // Add other response fields here
}

// Extended config type
export interface DeactivateInsuranceConfig extends ApiRequestConfig {
    travelId: string;
}

// Custom response type to include status code
export type DeactivateInsurance = ApiResponse<DeactivateInsuranceResponse>;

export const deactivateInsurance = async (config: DeactivateInsuranceConfig): DeactivateInsurance => {
    const { travelId, apis } = config;

    const body: DeactivateInsuranceRequest = {
        travelId,
        deactivatedOn: new Date().toISOString(),
        source: 'Web',
    };

    const queryParams = new URLSearchParams({
        product: 'TravelInsurance',
    });

    return await createAuthenticatedApiCall<DeactivateInsuranceResponse>({
        baseUrl: `${apis.methods.deactivate}?${queryParams}`,
        method: 'PUT',
        body,
        config,
    });
};
